import { createRouter, createWebHistory } from "vue-router";
const routes = [
    {
        path: '/',
        name: 'index',
        component: ()=>import('../App.vue')
    }
]
const router = createRouter({
    history: createWebHistory('/'),
    routes, // `routes: routes` 的缩写
})
export default router


